module.exports = __webpack_public_path__ + "static/img/vEight1.0c9519e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vEight1.png
// module id = PJ5b
// module chunks = 2